import { Option } from "./types";

const useOptions = (options: Option[] | string[]) => {
    const firstItem = options[0];

    const isOptionArray = (firstItem as Option) !== null;

    const getValue = (o: Option | string) => isOptionArray ? (o as Option).value : o.toString();

    const getLabel = (o: Option | string) => isOptionArray ? (o as Option).label : o.toString();

    return [getValue, getLabel];
}

export default useOptions;